import React from 'react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

interface StatusBadgeDisplayProps {
	isActive: boolean;
	statusLabel?: string;
	activeLabel: string;
	inactiveLabel: string;
	className?: string;
}

/**
 * Display-only status badge component for showing entity status
 * Used in form headers to display current status (not editable)
 */
export const StatusBadgeDisplay: React.FC<StatusBadgeDisplayProps> = ({
	isActive,
	statusLabel,
	activeLabel,
	inactiveLabel,
	className
}) => {
	return (
		<div className={cn('inline-flex items-center gap-2', className)}>
			{statusLabel && (
				<span className="text-sm font-medium text-gray-700 dark:text-gray-300">
					{statusLabel}
				</span>
			)}
			<Badge
				variant={isActive ? 'default' : 'outline'}
				className={
					isActive
						? undefined
						: 'border-amber-200 bg-amber-50 text-amber-800 dark:border-amber-800/60 dark:bg-amber-950/30 dark:text-amber-200'
				}
			>
				{isActive ? activeLabel : inactiveLabel}
			</Badge>
		</div>
	);
};
